import '../components/quantity-selector.js';
import '../components/insurance-activator.js';
import renderSectionFromResponse from '../utils/render-section-from-response.js';
import updateBagCount from '../utils/update-bag-count.js';
import dispatchEvent from '../utils/dispatch-event.js';
import CycleschemeRedemptionForm from '../components/cyclescheme-redemption-form.js';

class CartPage extends HTMLElement {
  constructor() {
    super();

    this.insuranceActivators = [
      ...document.querySelectorAll('insurance-activator'),
    ];
    this.insuranceDOB = document.querySelector('[data-insurance-dob]');
    this.insuranceDOBError = document.querySelector('[ data-dob-error]');
    this.insuranceDOBContainer = document.querySelector(
      '[data-insurance-dob-container]'
    );
    this.termsCheckbox = document.querySelector('[data-terms]');
    this.checkoutButton = document.querySelector('[data-checkout-button]');

    document.addEventListener('DOMContentLoaded', () => {
      this.initCycleschemeForm();
      this.registerEventListeners();
    });

    document.addEventListener('cart:rerendered', () => {
      this.initCycleschemeForm();
      this.registerEventListeners();
    });

    document.addEventListener('cart:quantity-updated', () => {
      fetch('/cart?sections=cart')
        .then(response => response.json())
        .then(response => {
          renderSectionFromResponse('[data-cart-page]', 'cart', response);
          updateBagCount();

          setTimeout(() => {
            dispatchEvent('cart:rerendered', document);
          }, 500);
        });
    });

    [...document.querySelectorAll('[data-electric-bike-item]')].forEach(
      bikeLineItem => {
        fetch('/cart/change.js', {
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          method: 'POST',
          body: JSON.stringify({
            line: bikeLineItem.dataset.lineIndex,
            quantity: bikeLineItem.dataset.quantity,
            properties: {
              ...Object.fromEntries(
                JSON.parse(bikeLineItem.dataset.currentProperties)
              ),
              _preorder_date: bikeLineItem.dataset.preorderDate,
              _backorder_date: bikeLineItem.dataset.backorderDate,
              'Pre-order Ship Date': bikeLineItem.dataset.preorderDate || null,
            },
          }),
        }).then(() => {
          dispatchEvent('cart:properties-updated', document);
        });
      }
    );
  }

  // eslint-disable-next-line class-methods-use-this
  initCycleschemeForm() {
    const form = document.querySelector('[data-cyclescheme-redemption-form]');

    if (form) {
      // eslint-disable-next-line no-new
      new CycleschemeRedemptionForm(form);
    }
  }

  registerEventListeners() {
    let debounceTimer;

    this.insuranceDOB.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.validateDate();
        this.updateCheckoutButton();
      }, 1000);
    });

    this.termsCheckbox.addEventListener('change', () =>
      this.updateCheckoutButton()
    );

    this.insuranceActivators.forEach(insuranceActivator => {
      const checkbox = insuranceActivator.querySelector(
        'input[type="checkbox"]'
      );

      checkbox.addEventListener('click', () => {
        this.updateDate();
        this.updateCheckoutButton();
      });
    });
  }

  updateCheckoutButton() {
    this.checkoutButton.classList.toggle(
      'btn-disabled',
      !this.isCheckoutValidated()
    );
  }

  isCheckoutValidated() {
    if (!this.termsCheckbox.checked) {
      return false;
    }

    let insuranceActivated = false;
    this.insuranceActivators.forEach(insuranceActivator => {
      const checkbox = insuranceActivator.querySelector(
        'input[type="checkbox"]'
      );

      if (checkbox.checked) {
        insuranceActivated = true;
      }
    });

    if (insuranceActivated) {
      return !!this.insuranceDOB.value;
    }

    return true;
  }

  updateDate() {
    let insuranceActivated = false;
    this.insuranceActivators.forEach(insuranceActivator => {
      const checkbox = insuranceActivator.querySelector(
        'input[type="checkbox"]'
      );

      if (checkbox.checked) {
        insuranceActivated = true;
      }
    });

    if (insuranceActivated) {
      this.insuranceDOBContainer.classList.remove('hidden');
    } else {
      console.log(`Insurance deselected: clearing DOB ${this.insuranceDOB.value} from form.`)
      this.insuranceDOB.value = '';
      this.insuranceDOBContainer.classList.add('hidden');
      console.log(`halting at cleared attr value; current value is ${this.insuranceDOB.value}`);
    }
  }

  clearDOB(){
    const formData = new FormData();
    formData.append('attributes[dob]', '');
    console.log(`sending body data with '' DOB value: ${JSON.stringify(formData)}`)
    fetch('cart/update.js', {
      method: 'POST',
      body: formData,
    })
    .then(response => response.json())
    .then(data => console.log(data));
  }

  validateDate() {
    if (this.insuranceDOB.value) {
      // Check if the user has entered an invalid date...
      if (!this.insuranceDOB.checkValidity()) {
        // If so, remove the invalid date.
        this.insuranceDOB.classList.add('!border-red-500');
        this.insuranceDOB.classList.remove('md:border-transparent');
        this.insuranceDOB.value = '';
        this.insuranceDOBError.classList.remove('hidden');
        setTimeout(() => {
          this.insuranceDOBError.classList.add('hidden');
          this.insuranceDOB.classList.add('md:border-transparent');
          this.insuranceDOB.classList.remove('!border-red-500');
        }, 5000);
        return false;
      } else {
        this.insuranceDOB.classList.add('md:border-transparent');
        this.insuranceDOB.classList.remove('!border-red-500');
        console.log(`halting at validation; current value is ${this.insuranceDOB.value}`);
      }
    }
  }
}

customElements.define('cart-page', CartPage);
